import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

export default function NoApproverModal({ open, onClose, message }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>No Eligible Approver</DialogTitle>
      <DialogContent>
        <Typography>
          {message || 'This space has no eligible approver for this content. Please ask your space administrator to assign an approver before submitting.'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">OK</Button>
      </DialogActions>
    </Dialog>
  );
}
